import React from "react";
import Layout from "../components/layout/LPLayout";
import { graphql } from "gatsby";
import Img from "gatsby-image";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";
import { WMKLink, SEO } from "wmk-lib";
import Theme from "../vars/ThemeOptions";
import RichText from "../vars/RichText";
import get from "lodash/get";
import LPIconText from "../components/routes/LandingPage/LPIconText";

const Styled = {};
Styled.LandingPage = styled.div`
  @import url("https://fonts.googleapis.com/css2?family=Rajdhani:wght@400;700&display=swap");
  @import url("https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;700&display=swap");
  color: #707070;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: "Rajdhani", sans-serif;
  }
  p,
  span {
    font-family: "Nunito Sans", sans-serif;
  }
`;

const baseUrl = `://${Theme.paths.baseUrl}`;
const siteTitle = "Watermark Agency";

export default ({ data }) => {
  const { lp, dfifLogo, timerBg, stopAapiHateLogo } = data;
  // console.log('data from lp.js: ', data);
  const {
    title,
    slug,
    mainImage,
    ogImage,
    twitterImage,
    subTitle,
    blocks,
  } = lp;
  // const timer = slug === "denver-feed-it-forward";
  const timer = false;
  return (
    <Layout>
      <SEO.Meta
        baseUrl={baseUrl}
        siteTitle={siteTitle}
        description={slug === "a-gaiter-for-change" || slug === "stop-aapi-hate" ? "Donate now and get a gaiter for change" : slug === "denver-feed-it-forward" ? "Help Denver Feed It Forward support frontline workers during this global pandemic" : "learn more"}
        title={title}
        slug={slug}
        path={"/lp/"}
        ogImage={
          ogImage && ogImage.fixed ? "https:" + ogImage.fixed.src : undefined
        }
        twitterImage={
          twitterImage && twitterImage.fixed
            ? "https:" + twitterImage.fixed.src
            : undefined
        }
        twitterHandle="@WatermarkAgency"
      />
      <SEO.Schema baseUrl={baseUrl} siteTitle={siteTitle} />
      <Styled.LandingPage>
        {timer ? <CountdownTimerBanner bg={timerBg} dfif={dfifLogo} /> : <LPHeader title={title} subTitle={subTitle} mainImage={mainImage} slug={slug} stopAapiHateLogo={stopAapiHateLogo} />}
        <Blocks blocks={blocks} slug={slug} />
      </Styled.LandingPage>
    </Layout>
  );
};

export const query = graphql`
  query lpQuery($slug: String!) {
    lp: contentfulLandingPages(slug: { eq: $slug }) {
      ...NodeLandingPagesFields
    }
    dfifLogo: contentfulAsset(title: {eq: "denver feed it forward icon no subtext"}) {
      title
      fluid {
        ...GatsbyContentfulFluid
      }
    }
    timerBg: contentfulAsset(title: {eq: "Blue Rectangle with Stopwatch"}) {
      title
      fluid {
        ...GatsbyContentfulFluid
      }
    }
    stopAapiHateLogo: contentfulAsset(title: {eq: "Stop AAPI Hate official logo"}) {
      title
      fluid {
        ...GatsbyContentfulFluid
      }
    }
  }
`;

Styled.Header = styled(Row)`
  position: relative;
  height: 28rem;
  background: rgb(254, 225, 71);
  background: linear-gradient(
    90deg,
    rgba(254, 225, 71, 1) 0%,
    rgba(238, 161, 23, 1) 100%
  );
  .img-col {
    height: 100%;
    .gatsby-image-wrapper {
      height: 100%;
    }
  }
  &.stop-aapi-hate {
    margin-bottom: 2rem !important;
  }
  @media only screen and (min-width: 1800px) {
    .img-col {
      .gatsby-image-wrapper {
        img {
          object-fit: contain !important;
          left: 10vw !important;
        }
      }
    }
  }
  @media only screen and (max-width: 1200px) {
    .img-col {
      .gatsby-image-wrapper {
        img {
          position: absolute;
          right: 0;
          object-position: right !important
        }
      }
    }
  }
  @media only screen and (max-width: 767px) {
    .img-col {
      display: none;
    }
    display: flex !important;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;
Styled.HeadLines = styled.div`
  padding-left: 2vh;
  position: absolute;
  top: 0;
  left: 50%;
  @media screen and (max-width: ${Theme.break.sm}){
    left: 40%;
  }
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  color: #707070;
  text-transform: uppercase;
  font-family: "Rajdhani", sans-serif;
  h2 {
    font-weight: 700;
    font-size: 4rem;
    margin-bottom: 3rem;
    @media screen and (max-width: ${Theme.break.md}) {
      margin-bottom: 2.5rem;
    }
    @media screen and (max-width: ${Theme.break.sm}) {
      margin-bottom: 1.5rem;
      font-size: 1.25rem;
    }
  }
  h1 {
    font-weight: 700;
    font-size: 5rem;
    line-height: 0.75;
    @media screen and (max-width: ${Theme.break.md}) {
      font-size: 3rem;
    }
  }
  .headline-image-wrap {
    width: 100%;
    // display: flex;
    // justify-content: center;
    .gatsby-image-wrapper {
      width: 12rem;
    }    
  }
  .aapi-title-wrap {
    display: flex;
    align-items: center;
    position: relative;
    top: -2rem;
    left: -30px;
    svg {
      transform: scale(.8);
      position: relative;
      top: 8px;
    }
    h1 {
      position: relative;
      left: -15px;
    }
  }
  @media only screen and (max-width: 767px) {
    position: relative;
    padding-left: 0;
    left: 0 !important;
    .headline-image-wrap {
      display: flex;
      justify-content: center;
      .gatsby-image-wrapper {
        position: relative;
      }
    }
  }
`;

const LPHeader = ({ title, mainImage, slug, stopAapiHateLogo }) => {
  return (
    <Styled.Header style={{ width: "100%", overflow: "hidden", margin: 0 }} className={slug}>
      <Col xs={0} sm={6} md={{ span: 5, offset: 1 }} className="img-col">
        <Img fluid={mainImage.fluid} alt={mainImage.title} />
      </Col>

      <Styled.HeadLines>
        {slug === "stop-aapi-hate"
          ? <div className="headline-image-wrap"><Img fluid={stopAapiHateLogo.fluid} alt={stopAapiHateLogo.title} /></div>
          : <h2>{title}</h2>
        }
        {slug === "stop-aapi-hate"
          ? <div className="aapi-title-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="150" height="223" viewBox="0 0 150 223">
                <text id="_" data-name="#" transform="translate(0 167)" fill="#fff" font-size="223" font-family="Rajdhani-Bold, Rajdhani" font-weight="700" opacity="0.352"><tspan x="0" y="0">#</tspan></text>
              </svg>
              <h1>
                Better
                <br />
                Together
              </h1>
            </div>
          : <h1>
              Better
              <br />
              Together
            </h1>
        }
      </Styled.HeadLines>
    </Styled.Header>
  );
};

const TimerWrap = styled.div`
  padding: 3rem 0 2rem;
  position: relative;
  .time-wrap {
    position: relative;
    z-index: 1;
    width: 60%;
    display: flex;
    // margin-left: 3rem;
    .cd-piece-wrap {
      text-align: center;
      margin: 0 .5rem 0;
      .numbers-wrap {
        display: flex;
        justify-content: center;
        div {
          background: #002647;
          color: white;
          border-radius: 5px;
          font-size: 2rem;
          width: 2.5rem;
          height: 3rem;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0 3px;
        }
      }
    }    
  }
  .img-copy-row {
    position: relative;
    z-index: 1;
    position: relative;
    left: -4rem;
    display: flex;
    align-items: center;
    height: 3rem;
    .gatsby-image-wrapper {
      height: 100%;
      width: 15rem;
      transform: scale(.4);
      position: relative;
      top: -10px;
    }
    p {
      font-size: 1.15rem;
      font-weight: bold;
      position: relative;
      left: -55px;
      background: -webkit-linear-gradient(45deg, #FFE000, #FC9D00);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .bg-image-wrap {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    .gatsby-image-wrapper {
      height: 100%;
    }
  }
`

const CountdownTimerBanner = ({ bg, dfif }) => {
  // Set the date we're counting down to
  var countDownDate = new Date("Dec 14, 2020 23:59:59").getTime();
  // Update the count down every 1 second
  var x = setInterval(function() {
    // Get today's date and time
    var now = new Date().getTime();
    // Find the distance between now and the count down date
    var distance = countDownDate - now;      
    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    days = days.toString().length === 1 ? `0` + days : days.toString();
    document.getElementById("days1").innerHTML = days.split("")[0];
    document.getElementById("days2").innerHTML = days.split("")[1];
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    hours = hours.toString().length === 1 ? `0` + hours : hours.toString();
    document.getElementById("hours1").innerHTML = hours.split("")[0];
    document.getElementById("hours2").innerHTML = hours.split("")[1];
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    minutes = minutes.toString().length === 1 ? `0` + minutes : minutes.toString();
    document.getElementById("minutes1").innerHTML = minutes.split("")[0];
    document.getElementById("minutes2").innerHTML = minutes.split("")[1];
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    seconds = seconds.toString().length === 1 ? `0` + seconds : seconds.toString();
    document.getElementById("seconds1").innerHTML = seconds.split("")[0];
    document.getElementById("seconds2").innerHTML = seconds.split("")[1];
    // If the count down is over, display all time pieces as 0
    if (distance < 0) {
      clearInterval(x);
      document.getElementById("days1").innerHTML = '0';
      document.getElementById("days2").innerHTML = '0';
      document.getElementById("hours1").innerHTML = '0';
      document.getElementById("hours2").innerHTML = '0';
      document.getElementById("minutes1").innerHTML = '0';
      document.getElementById("minutes2").innerHTML = '0';
      document.getElementById("seconds1").innerHTML = '0';
      document.getElementById("seconds2").innerHTML = '0';
    }
  }, 1000);
  return(
    <TimerWrap>
      <Container style={{maxWidth:"800px"}}>
        <div className="time-wrap">
          <div className="cd-piece-wrap">
            <div className="numbers-wrap">
              <div id="days1" />
              <div id="days2" />
            </div>         
            <p>DAYS</p> 
          </div>
          <div className="cd-piece-wrap">
            <div className="numbers-wrap">
              <div id="hours1" />
              <div id="hours2" />
            </div>  
            <p>HOURS</p>         
          </div>
          <div className="cd-piece-wrap">
            <div className="numbers-wrap">
              <div id="minutes1" />
              <div id="minutes2" />
            </div>          
            <p>MINUTES</p>
          </div>
          <div className="cd-piece-wrap">
            <div className="numbers-wrap">
              <div id="seconds1" />
              <div id="seconds2" />
            </div>          
            <p>SECONDS</p>
          </div>
        </div>      
        <div className="img-copy-row">
          <Img fluid={dfif.fluid} alt={dfif.title} />
          <p>FOR 100% MATCH FOR THE FIRST $1,000</p>
        </div>
      </Container>      
      <div className="bg-image-wrap">
        <Img fluid={bg.fluid} alt={bg.title} />
      </div>
    </TimerWrap>
  )
}

const Blocks = ({ blocks, slug }) => {
  const blockTypes = {
    ContentfulGlobal: LPBlockGlobal,
    ContentfulIconText: LPIconText,
    ContentfulSocialMedia: LPBlockLink,
  };
  return (
    <>
      {blocks &&
        blocks.length &&
        blocks.map((block, i) => {
          const { __typename } = block;
          const JSX = blockTypes[__typename];
          return JSX ? <JSX key={"block" + i} block={block} slug={slug} /> : null;
        })}
    </>
  );
};

Styled.Button = styled(Container)`
  -webkit-flex: initial;
  display: flex;
  justify-content: center;
  padding: 1rem 0rem 2rem 0rem;
  .wmk-link {
    border: 1px solid #707070;
    padding: 1rem 4rem;
    border-radius: 1rem;
    text-transform: uppercase;
    color: #707070;
    font-weight: 700;
    font-family: Rajdhani, sans-serif;
    font-size: 1.5rem;
    transition: all 0.45s ease;
    :hover {
      color: white;
      background: ${Theme.hex("fire")};
      text-decoration: none;
      border-color: ${Theme.hex("tang")};
    }
  }
`;
const LPBlockLink = ({ block }) => {
  return (
    <Styled.Button>
      <WMKLink to={block.url} target="_self">
        Donate Now
      </WMKLink>
    </Styled.Button>
  );
};

Styled.BodyCopy = styled(Container)`
  font-family: "Nunito Sans", sans-serif;
`;

const LPBlockGlobal = ({ block }) => {
  // console.log('block: ', block);
  const { subtitle, title } = block;
  const richText = get(block, `richText.json`, null);
  return (
    <Styled.BodyCopy style={{ padding: "4vh 2vh" }}>
      <Row
        className="flex-column"
        style={{ maxWidth: "700px", margin: "auto" }}
      >
        {title && (
          <Col>
            <h2>{title}</h2>
          </Col>
        )}
        {subtitle && (
          <Col>
            <h3>{subtitle}</h3>
          </Col>
        )}
        <br />
        {richText && (
          <Col>
            <RichText json={richText} />
          </Col>
        )}
      </Row>
    </Styled.BodyCopy>
  );
};




